import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const siteUrl = "https://apsensyscare.com";

export default function SchemaMarkup({ product }) {
  const { pathname } = useLocation();

  let schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Apsensys Care",
    "url": siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": `${siteUrl}/assets/images/logo.png`
    },
    "sameAs": [
      "https://www.facebook.com/apsensyscare",
      "https://www.instagram.com/apsensyscare",
      "https://www.linkedin.com/company/apsensyscare"
    ]
  };


  // Product page schema
  if (product) {
    schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": product.name,
      "image": [
        product.image
      ],
      "description": product.description,
      "brand": {
        "@type": "Brand",
        "name": "Apsensys Care"
      },
      "offers": {
        "@type": "Offer",
        "url": `${siteUrl}${pathname}`,
        "priceCurrency": "INR",
        "price": product.price,
        "availability": product.stock
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock"
      }
    };
  }


  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}